import { engineComponent, ArrayUtils, Utils } from "neo-common";
import { ContainerElement } from "../Components/Elements/Graphics/ContainerElement";
import { PaylinesDefinitions } from "./PaylinesDefinitions";
import { Payline, PaylineAttributes } from "./Payline";
import { Configuration, GeneralConfigurationAttributes } from "../Components/Configuration";
import { ComponentTypes } from "../Components/ComponentTypes";
import { PaylinesAttributes } from "./Paylines";
import { Winframe } from "./Winframe";
import { SwitchElement } from "../Components/Elements/Graphics/SwitchElement";

/**
 * Winframes class is holder for all winframes.
 * Winframes define behaviour of winframes on screen.
 * @class Winframes
 * @extends ContainerElement
 */
@engineComponent(ComponentTypes.DisplayObject)
export class Winframes extends ContainerElement {
    private _paylineIDs: Array<number>;
    private _paylines: Array<Payline>;
    private _specialContainer: ContainerElement;

    protected reelCount: number;
    protected symbolCount: number;
    protected reelX: Array<number>;
    protected reelY: Array<number>;
    protected symbolWidth: number;
    protected symbolHeight: number;

    private _winframes: Array<Array<SwitchElement>> = [];
    public get winframes(): Array<Array<SwitchElement>> {
        return this._winframes;
    }

    constructor() {
        super();

        this._paylines = [];
    }

    /**
     * Get attributes from xml and set up supported properties.
     * @method create
     * @param node is Element from xml
     * @return void
     */
    createByNode(node: Element) {
        super.createByNode(node);

        if (node.hasAttribute(PaylinesAttributes.CONFIGS)) {
            var configs: Array<string> = node.getAttribute(PaylinesAttributes.CONFIGS).split(";");
            for (var i: number = 0; i < configs.length; i++) {
                var config: Element = Configuration.Configurations[configs[i]];
                if (config != null) {
                    this.configurate(config);
                }
            }
        }

        if (this.childs != null) {
            let winframe: SwitchElement;
            for (var key in this.childs) {
                if (key === "Winframe" && this.childs[key] instanceof SwitchElement) {
                    winframe = this.childs[key];
                }
            }

            if (!Utils.isNullOrUndefined(winframe)) {
                for (let reelIndex: number = 0; reelIndex < this.reelCount; reelIndex++) {
                    this._winframes[reelIndex] = [];
                    for (let symbolIndex: number = 0; symbolIndex < this.symbolCount; symbolIndex++) {
                        let winFrame: SwitchElement = winframe.clone();
                        winFrame.name = reelIndex + "_" + symbolIndex;
                        winFrame.x = this.reelX[reelIndex];
                        winFrame.y = this.reelY[reelIndex] + this.symbolHeight * symbolIndex;
                        this.addChild(winFrame);
                        this._winframes[reelIndex][symbolIndex] = winFrame;
                    }
                }
                this.removeChild(this.childs["Winframe"]);
            }

            /*this.children.sort((a: any, b: any) => {
				if (a.hasOwnProperty(PaylineAttributes.Z_INDEX) && b.hasOwnProperty(PaylineAttributes.Z_INDEX)) {
					a.zIndex = a.zIndex || 0;
					b.zIndex = b.zIndex || 0;

					return a.zIndex - b.zIndex;
				}

				return 0;
			});*/
        }
    }

    setSpecialContainer(container: ContainerElement): void {
        this._specialContainer = container;
    }

    /**
     * Get attributes from configuration and set up supported properties.
     * @method configurate
     * @param node is Element from xml
     * @return void
     */
    configurate(node: Element): void {
        if (node.hasAttribute(PaylinesAttributes.PAYLINE_IDS)) {
            this._paylineIDs = ArrayUtils.numberArray(node.getAttribute(PaylinesAttributes.PAYLINE_IDS));
        }

        if (node.hasAttribute(GeneralConfigurationAttributes.REEL_COUNT)) {
            this.reelCount = parseInt(node.getAttribute(GeneralConfigurationAttributes.REEL_COUNT));
        }
        if (node.hasAttribute(GeneralConfigurationAttributes.VISIBLE_SYMBOL_COUNT)) {
            this.symbolCount = parseInt(node.getAttribute(GeneralConfigurationAttributes.VISIBLE_SYMBOL_COUNT));
        }

        if (node.hasAttribute("ReelX")) {
            this.reelX = ArrayUtils.numberArray(node.getAttribute("ReelX"));
        }

        if (node.hasAttribute("ReelY")) {
            this.reelY = ArrayUtils.numberArray(node.getAttribute("ReelY"));
        }

        if (node.hasAttribute("SymbolWidth")) {
            this.symbolWidth = parseInt(node.getAttribute("SymbolWidth"));
        }

        if (node.hasAttribute("SymbolHeight")) {
            this.symbolHeight = parseInt(node.getAttribute("SymbolHeight"));
        }
    }

    /**
     * Set winning payline from response to case WIN.
     * @method goToWin
     * @param id number
     * @return void
     */
    goToWin(reelIndex: number, symbolIndex: number): void {
        if (this._winframes[reelIndex][symbolIndex] != null) {
            this._winframes[reelIndex][symbolIndex].goToCase(Payline.CaseWin);
        } else {
            if (DEBUG) {
                //this.log('ERROR no payline with id: ' + (id - 1));
            }
        }
    }

    /**
     * Reset all paylines to case NORMAL.
     * @method reset
     * @return void
     */
    reset(): void {
        /*for (var i: number = 0; i < this._winframes.length; i++) {
			if (this._specialContainer != null) {
				this._specialContainer.addChild(this._winframes[i]);
			}
			this._winframes[i].goToCase(Payline.CaseNormal);
		}*/
    }

    getWinframes(): Array<Array<SwitchElement>> {
        return this._winframes;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Winframes.ts
 **/